import React from "react";
import CompanyInformation from "./CreditSummaryAccordions/CompanyInformation";
import CreditRating from "./CreditSummaryAccordions/CreditRating";
import TradePayment from "./CreditSummaryAccordions/TradePayment";
import LegalFilings from "./CreditSummaryAccordions/LegalFilings";
import { IBusinessCreditReportResponse, BusinessCreditReportStatePII } from "../../../store/businessCreditReportService/types";

interface IProps {
    bCreditReportData: IBusinessCreditReportResponse;
    reportObject: BusinessCreditReportStatePII;
    showAsAccordion?: boolean;
    creditProvider?: any;
}
const CreditSummaryAccordions: React.FunctionComponent<IProps> = (props) => {
    return (
        <React.Fragment>
            <CompanyInformation reportObject={props.reportObject} showAsAccordion={props.showAsAccordion} creditProvider={props.creditProvider} />
            <CreditRating
                bCreditReportData={props.bCreditReportData}
                reportObject={props.reportObject}
                showAsAccordion={props.showAsAccordion}
                creditProvider={props.creditProvider}
            />
            <TradePayment
                bCreditReportData={props.bCreditReportData}
                reportObject={props.reportObject}
                showAsAccordion={props.showAsAccordion}
                creditProvider={props.creditProvider}
            />
            <LegalFilings reportObject={props.reportObject} showAsAccordion={props.showAsAccordion} />
        </React.Fragment>
    );
};

export default CreditSummaryAccordions;
